import { getActiveUser } from './user'
import { TokenType } from '../types/authTypes'

export const getAccessToken = () => {
  const activeUser = getActiveUser()
  return activeUser?.accessToken
}

export const getRefreshToken = () => {
  const activeUser = getActiveUser()
  return activeUser?.refreshToken
}

const getTokenExpiryTime = (type: TokenType) => {
  const activeUser = getActiveUser()
  const isAccessToken = type === TokenType.ACCESS
  return activeUser?.[isAccessToken ? 'accessTokenExpiryTime' : 'refreshTokenExpiryTime'] || 0
}

export const isTokenExpired = (type: TokenType) => {
  const tokenExpiryTime = new Date(getTokenExpiryTime(type)).getTime()
  const nowTime = new Date().getTime()

  return tokenExpiryTime <= nowTime
}
